import BaseModel from './base';

export const DEFAULT_SETTINGS = {
  min_score: 0,
  max_score: 100,
};

export default class ExpertiseCriteria extends BaseModel {
  constructor(criteria, url) {
    super(criteria, url);
    this.settings = criteria.settings || DEFAULT_SETTINGS;
    this.set = criteria?.set || null;
    this.name = criteria?.name || '';
  }
}
